(function (f) {
  var g;
  if (typeof window !== "undefined") {
    g = window
  } else if (typeof global !== "undefined") {
    g = global
  } else if (typeof self !== "undefined") {
    g = self
  } else {
    g = this
  }
  g.guideSdk = f()
})(function () {
  var callbackMaps = {};
  var callbackQueue = {};
  var isReady = false;
  var uid = 0;
  var messType = 'GUIDE';
  var originList = [
    'http://u8c-test.yyuap.com',
    'https://u8c-daily.yyuap.com',
  ];
  var origin = window.location.origin || window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
  originList.push(origin);

  var getUid = function () {
    return ++uid;
  };
  var emit = function (event) {
    try {
      var type = event.type.split(':');
      var name = type[0];
      var id = type[1];
      var data = typeof event.data === 'undefined' ? false : event.data;
      var map = callbackMaps[name];
      var destroy = typeof event.destroy === 'undefined' ? true : event.destroy;
    } catch (e) {
      console.log(e);
      return;
    }
    if (map && map[id]) {
      clearTimeout(map[id].timer);
      var result = map[id].callback(data);
      if (destroy) {
        delete map[id];
      }
      return result;
    }
  }
  var reg = function (name, callback, autoClear) {
    autoClear = typeof autoClear === 'undefined' ? true : autoClear;
    var map = callbackMaps[name];
    var uid = getUid();
    var callbackObj = {
      callback: callback,
      timer: autoClear ? setTimeout(function () {
        callback && callback(false);
        delete map[uid];
      }, 500) : 0
    };
    if (map) {
      map[uid] = callbackObj;
    } else {
      map = {};
      map[uid] = callbackObj;
      callbackMaps[name] = map;
    }
    return name + ':' + uid;
  };
  var trigger = function (event) {
    try {
      var name = event.type;
      var data = event.data;
      var queue = callbackQueue[name];
    } catch (e) {
      console.log(e);
      return;
    }
    if (queue && queue.length) {
      for (var i = 0, l = queue.length; i < l; i++) {
        queue[i](data);
      }
    }
  };
  var on = function (name, callback) {
    var queue = callbackQueue[name];
    if (queue) {
      queue.push(callback);
    } else {
      callbackQueue[name] = [callback];
    }
  };
  var postToDiwork = function (data) {
    data.messType = messType;
    window.parent.postMessage(JSON.stringify(data), '*');
  };
  var ready = function (callback) {
    var event = {
      type: reg('ready', callback)
    }
    if (isReady) {
      emit(event);
    } else {
      setTimeout(function () {
        emit(event);
      }, 0);
    }
  };
  var onData = function (callback) {
    on('data', callback);
  };
  var saveCall = function (data) {
    postToDiwork({
      detail: data,
      callbackId: reg('saveCall', function () { })
    });
  }

  window.addEventListener('DOMContentLoaded', function () {
    isReady = true;
  }, false);

  window.addEventListener('message', function (event) {
    var data = event.data;
    var origin = event.origin || event.originalEvent.origin;
    if ((originList.indexOf(origin) < 0 && origin.indexOf('yyuap') < 0 && origin.indexOf('diwork') < 0) || !data) {
      return;
    }
    try {
      if (typeof data === 'string') {
        data = JSON.parse(data);
      }
    } catch (e) {
      console.log(e);
      return;
    }
    if (data && typeof data === 'object' && data.type) {
      if (data.type.indexOf(':') < 0) {
        trigger(data);
      } else {
        emit(data);
      }
    }
  }, false);

  window.addEventListener('click', function () {
    postToDiwork({
      callbackId: 'rootClick',
    })
  }, false);

  return {
    ready: ready,
    onData: onData,
    saveCall: saveCall,
  };
});
